import * as React from "react";
import { ValueProposition } from "components/flexComponents/Hotels/components/ValueProposition";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";

export const HotelAddressDistanceToPoiAndValuePropositionCOMET = ({
  hotel,
  address,
  distance,
  showAddress,
  showDistance,
  isViewCarousel
}: {
  hotel: Hotel;
  address?: string;
  distance?: string;
  showAddress?: boolean;
  showDistance?: boolean;
  isViewCarousel?: boolean;
}) => {
  return (
    <>
      {showAddress && <div className="uitk-type-300">{address}</div>}

      <ValueProposition hotel={hotel} />

      {showDistance && (
        <div className={isViewCarousel ? "uitk-type-300 truncate" : "uitk-type-300 all-t-padding-three"}>
          <UitkIcon name="place" size={UitkIconSize.MEDIUM} />
          <span className="all-l-padding-two">{distance}</span>
        </div>
      )}
    </>
  );
};
